import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { NEWS_ITEMS } from '../data'

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}

export default function News() {
  return (
    <main style={{ padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 32px)', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Page header */}
        <div style={{ marginBottom: '64px', paddingBottom: '24px', borderBottom: '1px solid var(--border)' }}>
          <div className="section-label">Latest Updates</div>
          <h1 className="section-title">News</h1>
        </div>

        {/* News grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '1px',
            background: 'var(--border)',
          }}
        >
          {NEWS_ITEMS.map((item) => (
            <article
              key={item.id}
              style={{
                background: 'var(--ink)',
                padding: '32px 28px',
                display: 'flex',
                flexDirection: 'column',
                transition: 'background 0.2s',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--ink-2)')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.background = 'var(--ink)')}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <span
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '10px',
                    letterSpacing: '3px',
                    textTransform: 'uppercase',
                    color: 'var(--gold-dim)',
                  }}
                >
                  {formatDate(item.date)}
                </span>
                {item.category && (
                  <span
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '9px',
                      letterSpacing: '2px',
                      textTransform: 'uppercase',
                      color: 'var(--gold)',
                      border: '1px solid rgba(200,169,110,0.25)',
                      padding: '3px 8px',
                    }}
                  >
                    {item.category}
                  </span>
                )}
              </div>

              <h2
                style={{
                  fontFamily: 'var(--font-serif)',
                  fontSize: '20px',
                  fontWeight: 600,
                  color: 'var(--cream)',
                  lineHeight: 1.4,
                  marginBottom: '12px',
                  flex: 1,
                }}
              >
                {item.title}
              </h2>

              <p style={{ fontSize: '14px', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '24px' }}>
                {item.excerpt}
              </p>

              <Link
                to={`/news/${item.slug}`}
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase',
                  color: 'var(--gold-dim)',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold-dim)')}
              >
                Read More <ArrowRight size={10} />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </main>
  )
}
